import React from "react";
import PropTypes from "prop-types";
import { TableCell } from "@mui/material";
import { GREY_BACKGROUND } from "../constants/styleConstants";

export default function TableItem({ children, grey, header, ...rest }) {
  return (
    <TableCell
      align="center"
      sx={{
        fontWeight: header ? "bold" : "",
        backgroundColor: grey ? GREY_BACKGROUND : "",
      }}
      {...rest}
    >
      {children}
    </TableCell>
  );
}

TableCell.propTypes = {
  children: PropTypes.node,
  grey: PropTypes.bool,
  header: PropTypes.bool,
};
